// extracted by mini-css-extract-plugin
export default {"bg":"WeatherWidget_bg_FGvdA","fsBig":"WeatherWidget_fsBig_yPThI","value":"WeatherWidget_value_RWDuL","label":"WeatherWidget_label_abDHj"};